import { Slider } from "./Slider";
export class VSlider extends Slider {
}
